import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/img_logo.png'


const _withScopeId = n => (_pushScopeId("data-v-57a42390"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header_inner" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "header_logo",
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_3 = { class: "header_text" }


export default /*#__PURE__*/_defineComponent({
  __name: 'HeaderTypeB',
  props: {
  title: {
    type: String,
    default: '',
  },
},
  setup(__props) {

const props = __props



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("header", null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("p", _hoisted_3, _toDisplayString(props.title), 1)
    ])
  ]))
}
}

})